import React, {useState} from "react";
import {createPortal} from 'react-dom';
import { useForm, FormProvider } from 'react-hook-form';
import themeMaker, {bssMakeStyles}  from '../../lib/theming';
import Wrapper, { WaitKC } from '../Wrapper';
import { calcolaPreventivi } from '../../api/estimates';
import FrammentoLocalita from './frammenti/FrammentoLocalita';
import FrammentoPacchi from './frammenti/FrammentoPacchi';
import FrammentoSubmit from './frammenti/FrammentoSubmit';
import useBSSLogger from "../../hooks/useBSSLogger";

const {logger} = useBSSLogger();

import { Grid, Paper } from '@mui/material';
import { makeStyles } from "@mui/styles";

import { convertiFormRequestCalcola, DefaultSubmitErrorHandler } from "./Preventivo";
import __t from "../../lib/traduzioni";
import AlertNoQuotations from "./AlertNoQuotations";
import FrammentoPuntiRitiroConsegna from "./frammenti/FrammentoPuntiRitiroConsegna";
import FrammentoSelettoreRubrica from './frammenti/FrammentoSelettoreRubrica';
import { getNextUrl, nextUrlByStep } from "./frammenti/FrammentoRiepilogo";
import {v4 as uuidv4} from 'uuid'
import BSSForm from "../form/BSSForm";
import { useEffect } from "react";

const FormPreventivo = ({destLocalita = null, destPacchi = null, destSubmit = null, destRubrica = null, destPuntiritiro = null, abilitaPuntiRitiro = false,
    defaultValues, daShortcode, aggiornaPreventivoStorage, preventivoStorage,
    cfgSubmitStep1 = {}, 
    noQuotationsContacts = {
        tel: null, 
        whatsapp: null, 
        mail: null,
        link: null
    }, 
    fromStep = 1,
    nextUrl = null, 
    ...rest
}) => {
    
    logger.debug("parametri form preventivo", defaultValues)

    useEffect(() => {
        const eventoPreventivatore = new CustomEvent("spedizioniweb2_step_0", {
            detail: {//@todo definire dati da passare all'evento
                defaultValues
            }
        });
        document.dispatchEvent(eventoPreventivatore);
    }, [])

    const [mostraNessunPreventivo, setMostraNessunPreventivo] = useState(false)

    const classes = bssMakeStyles();
    const methods = useForm({
        defaultValues,
        reValidateMode: 'onBlur'
    });
    const {handleSubmit, formState, control} = methods;
    
    const onSubmit = async (data) => {

        const datiRequest = convertiFormRequestCalcola(data);
    
        logger.info("calcolo il preventivo per: ", datiRequest);
        
        try {
            
            const {currency, quotations} = await calcolaPreventivi(datiRequest);

            if(!Array.isArray(quotations) || (Array.isArray(quotations) && quotations.length === 0)){
                setMostraNessunPreventivo(true)
            } else {
                //const {idLocalePreventivo =  uuidv4()} = preventivoStorage 
                const datiDaForm = methods.getValues();
                aggiornaPreventivoStorage({
                    ...datiDaForm, 
                    step: 2, 
                    addizionali: undefined, 
                    preventivoSelezionato: undefined, 
                    preventivi: undefined,
                    noQuotationsContacts,
                    //idLocalePreventivo
                })
    
                logger.debug("salvataggio preventivo andato a buon fine, se definito faccio il redirect a", nextUrl)

                // if(nextUrl === null || nextUrl === undefined){

                //     nextUrl = nextUrlByStep(2)                    
        
                // }
        

                // if(nextUrl !== null) {
                //     location.href = nextUrl
                // }

                const eventoPreventivatore = new CustomEvent("spedizioniweb2_step_1", {
                    detail: {//@todo definire dati da passare all'evento
                        data,
                        quotations,
                        preventivoStorage
                    }
                });
                document.dispatchEvent(eventoPreventivatore);

                location.href = getNextUrl(nextUrl, 2, null)
            }


            
            
        } catch(err){
            logger.error("errore nel salvataggio del preventivo", err)
        }
        
    }
    
    
    const props = {destRubrica, destLocalita, destPuntiritiro, destPacchi, destSubmit};
    const dests = ["Rubrica", "Localita", "Puntiritiro", "Pacchi", "Submit"];

    const usePortals = dests.reduce((obj, dest) => {
        const selector = props[`dest${dest}`];
        const destel = document.querySelector(`#${selector}`);
        const esito = (selector !== null && destel !== null) ? destel : false;
        logger.finest({dest, selector, destel, esito})
        return {
            ...obj,
            [dest]: esito 
        }
    }, {})

    const fragmentDefualtProps = {
        methods,
        classes,
    }

    const submitProps = {
        ...fragmentDefualtProps,
        buttonProps: cfgSubmitStep1.buttonProps ?? {},
        onSubmit: handleSubmit(onSubmit, DefaultSubmitErrorHandler)
    }


    logger.debug("se l'utente è loggato?", spedizioniweb2.isloggedin(), "uso come wrapper WaitCK altrimenti uso Fragment")
    const WrapperFrammentoRubrica = spedizioniweb2.isloggedin() ? WaitKC : React.Fragment
    
    return (
        <>
            <FormProvider {...methods}>
                <BSSForm onSubmit={handleSubmit(onSubmit, DefaultSubmitErrorHandler)}>                    
                    <Paper elevation={3} className={`${classes.rounded10} ${classes.container}`}>                        

                        <Grid container >

                            {spedizioniweb2.isloggedin() && (
                                <WrapperFrammentoRubrica>
                                    {(usePortals["Rubrica"] !== false) ?
                                        createPortal(
                                            <Wrapper inPortal>
                                                <FrammentoSelettoreRubrica {...fragmentDefualtProps} daShortcode={daShortcode} />                                        
                                            </Wrapper>,  
                                            usePortals["Rubrica"]
                                        )
                                        : <FrammentoSelettoreRubrica {...fragmentDefualtProps} daShortcode={daShortcode} />                                    
                                    }
                                </WrapperFrammentoRubrica> 
                            )}

                            <>  
                                {(usePortals["Localita"] !== false)?
                                    createPortal(
                                        <Wrapper inPortal>
                                            <FrammentoLocalita {...fragmentDefualtProps} />                                        
                                        </Wrapper>,                                    
                                        usePortals["Localita"]
                                    )
                                    : <FrammentoLocalita {...fragmentDefualtProps} />
                                }
                            </>

                            <>
                                {abilitaPuntiRitiro !== false && (
                                    (usePortals["Puntiritiro"] !== false)?
                                        createPortal(
                                            <Wrapper inPortal>
                                                <FrammentoPuntiRitiroConsegna {...fragmentDefualtProps} daShortcode={daShortcode} />                                        
                                            </Wrapper>,  
                                            usePortals["Puntiritiro"]
                                        )
                                        : <FrammentoPuntiRitiroConsegna {...fragmentDefualtProps} daShortcode={daShortcode} />
                                )}
                            </> 
                            
                            <>
                                {(usePortals["Pacchi"] !== false)?
                                    createPortal(
                                        <Wrapper inPortal>
                                            <FrammentoPacchi {...fragmentDefualtProps} daShortcode={daShortcode} />                                        
                                        </Wrapper>,  
                                        usePortals["Pacchi"]
                                    )
                                    : <FrammentoPacchi {...fragmentDefualtProps} daShortcode={daShortcode} />
                                }
                            </>                            

                            
                            <>
                                {/* <pre>{JSON.stringify(noQuotationsContacts, null, 2)}</pre> */}
                                {mostraNessunPreventivo && (                                    
                                    <Grid item xs={12} className={classes.formGroupBox} >
                                        <AlertNoQuotations 
                                            noQuotationsContacts={noQuotationsContacts} 
                                            inSnackbar={fromStep !== 1} 
                                            mostraNessunPreventivo={mostraNessunPreventivo} 
                                            setMostraNessunPreventivo={setMostraNessunPreventivo}
                                        />
                                    </Grid>
                                )}


                                {(usePortals["Submit"] !== false)?
                                        createPortal(
                                            (cfgSubmitStep1?.wrapped ?? true) ? (
                                                <Wrapper inPortal>                                     
                                                    <FrammentoSubmit {...submitProps} />                                        
                                                </Wrapper>
                                            ) : (
                                                <FrammentoSubmit {...submitProps} />                                                                                        
                                            )                                            
                                            ,  
                                            usePortals["Submit"]
                                        )
                                        : <FrammentoSubmit {...submitProps} />                                        
                                }                                
                                
                            </>
                            
                        </Grid>
                    </Paper>        
                </BSSForm>
            </FormProvider>

        </>
    )
}

export default FormPreventivo
